import { MessageStatus, type StaffCommunicationHistoryResponse, type UserSentMessage, type UserSentMessagesCollection } from "../../../utils/models";

export function combineStaffCommunicationHistory(pages: StaffCommunicationHistoryResponse[], departmentId: string): UserSentMessage[] {
	return pages.flatMap((page) => [
		...page.sms,
		...page.push.map(
			(push): UserSentMessage => ({
				id: push.id,
				departmentId,
				userId: push.userId,
				status: push.status === "sent" ? MessageStatus.delivered : MessageStatus.failed,
				body: push.body,
				dateCreated: push.dateSent,
				direction: "outbound",
				isPush: true,
				platform: push.platform,
				title: push.title,
				sid: push.pushId,
			}),
		),
	]);
}

export function failedStatusToString(status: MessageStatus): string | null {
	switch (status) {
		case "failed":
			return "Failed to send";
		case "undelivered":
			return "Message Undelivered";
		default:
			return null;
	}
}

export function getFilteredThreads(requiredStatuses: MessageStatus[], threads: UserSentMessagesCollection): UserSentMessagesCollection {
	return Object.fromEntries(
		Object.entries(threads).map(([key, values]) => {
			const firstMessage = values.length ? values.reduce((max, msg) => (msg.dateCreated > max.dateCreated ? msg : max)) : undefined;
			return [
				key,
				requiredStatuses.length === Object.values(MessageStatus).length || !firstMessage
					? values
					: values.filter(
							(v) =>
								requiredStatuses.includes(v.status) &&
								![MessageStatus.sent, MessageStatus.delivered].includes(firstMessage.status) &&
								((failedStatusToString(firstMessage.status) !== null && failedStatusToString(v.status) !== null) ||
									(failedStatusToString(firstMessage.status) === null && failedStatusToString(v.status) === null)),
						),
				/*This filter means, either give me all when all statuses are selected as filter.
				 * if a specific filter is selected, is the latest message failed or undelivered? If so, only give me messages that are also failed or undelivered.
				 * If the latest message is not failed or undelivered, then give me all messages that are not failed or undelivered.(like in sending state)
				 */
			];
		}),
	);
}
